import { Table } from "antd";
import React from "react";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import FilterOptions from "../../components/Common/antdFilterOptions";
import UploadExcel from "../../components/Common/uploadExcel";
import Deletepopup from "../../components/Modal/AntdDeletepopup";
import Pagination from "../../components/Common/CommonPagination/index";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import NavBarTitles from "../../components/Common/TabBar";
import AddButton from "../../components/Common/addButton";
import scroll from "../../assets/webp/scroll.webp";

const MasterListLayout = ({
  title,
  breadcrumbsList,
  onAdd,
  uploadApi,
  columns,
  records,
  count,
  pages,
  limit,
  skip,
  handlePageChange,
  handleDelete,
  deleteModal,
  setDeleteModal,
  handleClose,
  setLimit,
  handleSortClick,
  onChangeSearch,
  navBarData,
  loader = false,
}) => {
  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={breadcrumbsList}
            />
            <div className="d-flex gap-4 align-items-center">
              <div className="bgPrimary addBtn">
                <AddButton
                  onClick={onAdd}
                  addBtn={true}
                  btnContent={`Add ${title}`}
                />
              </div>
              <UploadExcel
                apiUrl={uploadApi}
                list_api_call={handlePageChange}
              />
            </div>
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              Total {title}s: {count}
            </div>
            {count > limit && (
              <Pagination
                skip={skip}
                limit={limit}
                total={count}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          <NavBarTitles titles={navBarData} />
          <FilterOptions
            limit={limit}
            handleSortClick={handleSortClick}
            setLimit={setLimit}
            filterBy={false}
            onChangeSearch={onChangeSearch}
            title={title}
          />
          {!loader ? (
            <Table
              columns={columns}
              dataSource={records}
              pagination={false}
              rowKey="_id"
              className="mx-3 pt-2 table-scrollable masterList_table "
              scroll={{ x: "max-content" }}
            />
          ) : (
            <div className="d-flex justify-content-center">
              <img src={scroll} width={150} alt="loader" />
            </div>
          )}
        </div>
      </MainconternLayout>

      {deleteModal.status && (
        <Deletepopup
          handleDelete={handleDelete}
          id={deleteModal?.id}
          isCloseModalEnable={true}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default MasterListLayout;
